import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Tenant',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'createdAt',
        'name',
        'sectionName',
        'staffName',
        'communityCount',
        'status',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          createdAt: '登録年月日',
          name: 'テナント名',
          sectionName: '担当部門',
          staffName: 'コミュニティ担当者',
          communityCount: 'コミュニティ数',
          status: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          createdAt: 'wp-10',
          name: '',
          sectionName: '',
          staffName: '',
          communityCount: '',
          status: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'createdAt',
          'name',
          'sectionName',
          'staffName',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // // 検索
      // searchName: null,
      // searchStatus: '',

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  beforeDestroy() {
    if (this.$route.name !== 'TenantDetail') {
      this.reset()
    }
  },
  computed: {
    ...mapState({
      categoryName: state => state.tenant.categoryName,
      tenantModel: state => state.tenant.tenantModel,
      syncProccesing: state => state.admp.proccesing,

      // 検索
      filters: state => state.tenant.filters,
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    loadingDescription () {
      return this.syncProccesing
        ? 'ADMP同期中'
        : ''
    },

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // filter
    searchName: {
      get () {
        return this.filters.searchName
      },
      set (value) {
        this.setInputFilter({
          key: 'searchName',
          value: value
        })
      }
    },
    searchStatus: {
      get () {
        return this.filters.searchStatus
      },
      set (value) {
        this.setInputFilter({
          key: 'searchStatus',
          value: value
        })
      }
    },
  },
  watch: {
    syncProccesing: function (to) {
      if (!to) {
        this.init()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'tenant/loadModel',
      loadTenantList: 'tenant/loadTenantList',
      syncAdmp: 'admp/sync',
      reset: 'tenant/reset'
    }),
    ...mapMutations({
      setInputFilter: 'tenant/setInputFilter',
    }),

    init () {
      this.loading = true

      // データ検索パラメータ
      let tenantParams = { filters: {} }
      if (this.searchName)
        tenantParams.filters.tenantName = this.searchName
      if (this.searchStatus !== '')
        tenantParams.filters.tenantStatus = this.searchStatus

      // データ読出し
      this.loadModel({
        tenantParams: tenantParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.tenantModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'createdAt':
          return Utility.dateFormat(props.row.tenant[key], 'YYYY/MM/DD')
        case 'name':
        case 'sectionName':
        case 'staffName':
          return props.row.tenant[key]
        case 'status':
          return Utility.getConstantsLabel(['Status'], props.row.tenant[key])
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 検索
    resetSearch () {
      this.searchName = null
      this.searchStatus = ''

      this.init()
    },
    search () {
      this.loading = true

      // データ検索パラメータ
      let tenantParams = { filters: {} }
      if (this.searchName)
        tenantParams.filters.tenantName = this.searchName
      if (this.searchStatus !== '')
        tenantParams.filters.tenantStatus = this.searchStatus

      // データ読出し
      this.loadTenantList({
        tenantParams: tenantParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.tenantModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'TenantDetail',
        params: {
          tenantId: String(props.row.tenant.tenantUuid)
        }
      })
    },
  }
}